import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { QUERY_KEYS } from '@/utils/query-keys';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Resolution886ReportService } from '@/infra/services/resolution-886-report';
import { AdditionalEvaluation, AdditionalEvaluationOption } from '@/components/views/Resolution886/enums';

interface CreateAssessmentAdditionalEvaluationParams {
	organization_id: string;
	company_id: string;
	assessment_id: string;
	additional_evaluation: AdditionalEvaluation;
	additional_evaluation_option: AdditionalEvaluationOption | null;
	value: number;
}

const Service = Resolution886ReportService.getInstance();

export const useCreateAssessmentAdditionalEvaluation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: CreateAssessmentAdditionalEvaluationParams) =>
			Service.createAssessmentAdditionalEvaluation(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_RESOLUTION_886_CATEGORY]);
			queryClient.refetchQueries({
				queryKey: [QUERY_KEYS.GET_RESOLUTION_886_CATEGORY]
			});
		},
		onError: ({ response }) => {
			message.error(I18n.get(response.data.message));
		}
	});
};
